<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="城市销售"
                name="1"
                link="/report/sales/city"
            ></el-tab-pane>
            <el-tab-pane
                label="场地销售"
                name="2"
                link="/report/sales/site"
            ></el-tab-pane>
            <el-tab-pane
                label="艺人销售"
                name="3"
                link="/report/sales/artist"
            ></el-tab-pane>
            <el-tab-pane
                label="渠道销售"
                name="4"
                link="/report/sales/channel"
            ></el-tab-pane>
            <el-tab-pane
                label="终端销售"
                name="9"
                link="/report/sales/terminal"
            ></el-tab-pane>
            <el-tab-pane
                label="演出销售"
                name="5"
                link="/report/sales/show"
            ></el-tab-pane>
            <el-tab-pane
                label="巡演销售"
                name="6"
                link="/report/sales/touring"
            ></el-tab-pane>
            <el-tab-pane
                label="众筹销售"
                name="7"
                link="/report/sales/crowdfunding"
            ></el-tab-pane>
            <el-tab-pane
                label="周边销售"
                name="8"
                link="/report/sales/surrounding"
            ></el-tab-pane>
			<el-tab-pane
			    label="乐迷服务费"
			    name="10"
			    link="/report/sales/service"
			></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
    },
    data() {
        return {
            activeName: this.name,
        };
    },
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>